import { makeStyles } from "@mui/styles";
import theme from "mui/theme";

export const menuItemCategoryStyles = makeStyles(() => ({
  menu_item__active: {
    color: theme.palette.primary.dark,
  },
}));
